import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCountersinkingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			style: {},
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M91.7,52.6l-15.6-9l-26-15c-0.2-0.1-0.5-0.1-0.7,0L8.3,52.4C8,52.6,7.9,52.8,7.9,53v0V65 c0,0.3,0.1,0.5,0.4,0.6l24.6,14.2c0,0,0,0,0,0c0,0,0,0,0,0l0.2,0.1c0.2,0.1,0.4,0.1,0.6,0c0.2-0.1,0.4-0.2,0.4-0.4 c0.3-0.9,0.9-1.7,1.6-2.4c0.7-0.7,1.6-1.3,2.6-1.9c1.3-0.7,2.7-1.3,4.3-1.8l0.1,0c0,0,0,0,0,0c4.6-1.3,10-1.2,14.6,0.1 c0,0,0,0,0.1,0c1.6,0.5,3,1,4.2,1.8c1,0.6,1.9,1.3,2.6,2c0.8,0.8,1.3,1.6,1.7,2.5c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0.1,0.1,0.1,0.1 c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0l24.8-14.3c0.2-0.1,0.4-0.4,0.4-0.6V53.2 C92.1,52.9,92,52.7,91.7,52.6z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M92,52.1c-5-2.9-30.1-17.4-37.7-21.8c-1.2-0.7-3.6-2.8-5.1-2.2c-1.6,0.6-3.2,1.8-4.7,2.7 C36.9,35.2,14.8,48,11.5,49.9c-1.2,0.7-4,1.7-4.2,3.2c-0.2,1.6,0,3.3,0,4.9c0,2.1,0,4.1,0,6.2c0,1,0.3,1.6,1.1,2.1 c1.1,0.7,17,9.9,23.8,13.7c0.4,0.2,0.8,0.5,1.3,0.5c1-0.1,1.2-1.1,1.6-1.8c0.5-0.8,1.2-1.5,2-2.1c3-2.4,7-3.3,10.8-3.6 c3.9-0.3,7.9,0.2,11.5,1.7c1.8,0.8,3.6,1.8,4.9,3.4c0.6,0.7,0.8,1.9,1.6,2.4c0.8,0.4,1.5-0.1,2.1-0.5c1.3-0.8,21.4-12,23.8-13.8 c1-0.7,0.8-2,0.8-3.2c0-2.3,0-4.5,0-6.8C92.7,55.3,93.2,52.7,92,52.1z M79.5,58.6c-3-8.2-12.8-12-20.7-13.4 c-8.6-1.5-18-1-26.2,2.4c-5,2.1-10.1,5.5-12.1,10.8L11.3,53l38.6-22.3l38.9,22.4L79.5,58.6z M22.8,59.9c2-7.4,11.5-10.8,18.1-12.1 c10-1.9,22-0.9,30.6,5.1c2.6,1.8,5,4.3,5.8,7.4L66.7,76.9c-3.8-5-11.1-6.5-17-6.5c-5.7,0-12.8,1.6-16.3,6.4L22.7,60.1 C22.8,60.1,22.8,60,22.8,59.9z M90.1,55.5v8.9L70.6,75.6c2.2-3.5,4.5-7,6.7-10.5c0.7-1.1,1.3-2.7,2.3-3.5c0.4-0.4,1-0.6,1.5-0.9 C82.2,60,88.2,56.6,90.1,55.5z M29.2,75.3L9.9,64.2v-8.9c1.5,0.9,8.7,4.6,10.3,5.9c0.8,0.7,1.3,1.9,1.9,2.8 c1.4,2.2,2.8,4.5,4.2,6.7C27.3,72.3,28.3,73.8,29.2,75.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M21.2,35.6l-1-1.6v0c-0.4-0.6-1.1-0.7-1.7-0.4c-0.6,0.4-0.7,1.1-0.4,1.7l1,1.6 c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5-0.1,0.6-0.2C21.4,36.9,21.6,36.1,21.2,35.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M45,73.5c0.1-0.3,0-0.6-0.2-0.9l-2-3.1v0c-0.4-0.6-1.1-0.7-1.7-0.4c-0.6,0.4-0.7,1.1-0.4,1.7l2,3.1 c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5-0.1,0.6-0.2C44.8,74.1,45,73.8,45,73.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M33.2,55c0.1-0.3,0-0.6-0.2-0.9l-2-3.1c-0.4-0.6-1.1-0.7-1.7-0.4c-0.3,0.2-0.5,0.4-0.5,0.8 c-0.1,0.3,0,0.6,0.2,0.9l2,3.1c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5-0.1,0.6-0.2h0C32.9,55.6,33.1,55.3,33.2,55z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M25.3,42.7c0.1-0.3,0-0.6-0.2-0.9l-2-3.1c-0.4-0.6-1.1-0.7-1.7-0.4c-0.6,0.4-0.7,1.1-0.4,1.7l2,3.1 c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5-0.1,0.6-0.2C25.1,43.2,25.2,43,25.3,42.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M49,79.7c0.1-0.3,0-0.6-0.2-0.9l-2-3.1c-0.4-0.6-1.1-0.7-1.7-0.4c-0.3,0.2-0.5,0.4-0.5,0.8 c-0.1,0.3,0,0.6,0.2,0.9l2,3.1c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5-0.1,0.6-0.2C48.7,80.3,48.9,80,49,79.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M41.1,67.3c0.1-0.3,0-0.6-0.2-0.9l-2-3.1v0c-0.4-0.6-1.1-0.7-1.7-0.4c-0.3,0.2-0.5,0.4-0.5,0.8 c-0.1,0.3,0,0.6,0.2,0.9l2,3.1c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5-0.1,0.6-0.2C40.8,67.9,41,67.6,41.1,67.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M29.1,47.9l-2-3.1c-0.4-0.6-1.1-0.7-1.7-0.4c-0.6,0.4-0.7,1.1-0.4,1.7l2,3.1c0.2,0.3,0.6,0.6,1,0.6 c0.2,0,0.5-0.1,0.6-0.2C29.3,49.2,29.4,48.5,29.1,47.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M37.1,61.2c0.1-0.3,0-0.6-0.2-0.9l-2-3.1c-0.4-0.6-1.1-0.7-1.7-0.4c-0.3,0.2-0.5,0.4-0.5,0.8 c-0.1,0.3,0,0.6,0.2,0.9l2,3.1c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5-0.1,0.6-0.2C36.9,61.7,37.1,61.5,37.1,61.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M52.5,81.5L52.5,81.5c-0.6-0.4-1.3-0.2-1.7,0.4l0,0l0,0c-0.4-0.6-1.1-0.7-1.7-0.4 c-0.3,0.2-0.5,0.4-0.5,0.8c-0.1,0.3,0,0.6,0.2,0.9l1,1.6c0.2,0.3,0.6,0.6,1,0.6c0.4,0,0.8-0.2,1-0.6l1-1.6 C53.2,82.6,53,81.9,52.5,81.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M80.1,38.3c-0.6-0.4-1.3-0.2-1.7,0.4l-2,3.1c-0.4,0.6-0.2,1.3,0.4,1.7c0.2,0.1,0.4,0.2,0.6,0.2 c0.4,0,0.8-0.2,1-0.6l2-3.1C80.8,39.4,80.6,38.7,80.1,38.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M56.4,75.3c-0.6-0.4-1.3-0.2-1.7,0.4l-2,3.1c-0.2,0.3-0.2,0.6-0.2,0.9c0.1,0.3,0.3,0.6,0.5,0.8 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6l2-3.1C57.1,76.4,57,75.7,56.4,75.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M60.4,69.2L60.4,69.2c-0.6-0.4-1.3-0.2-1.7,0.4l-2,3.1c-0.4,0.6-0.2,1.3,0.4,1.7 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6l2-3.1c0.2-0.3,0.2-0.6,0.2-0.9C60.8,69.6,60.6,69.3,60.4,69.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M72.2,50.6c-0.6-0.4-1.3-0.2-1.7,0.4l-2,3.1c-0.2,0.3-0.2,0.6-0.2,0.9c0.1,0.3,0.3,0.6,0.5,0.8 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6l2-3.1c0.2-0.3,0.2-0.6,0.2-0.9C72.7,51.1,72.5,50.8,72.2,50.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M68.3,56.8c-0.6-0.4-1.3-0.2-1.7,0.4l-2,3.1c-0.2,0.3-0.2,0.6-0.2,0.9c0.1,0.3,0.3,0.6,0.5,0.8 c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6l2-3.1c0.2-0.3,0.2-0.6,0.2-0.9C68.7,57.3,68.5,57,68.3,56.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M64.3,63L64.3,63c-0.6-0.4-1.3-0.2-1.7,0.4l-2,3.1c-0.2,0.3-0.2,0.6-0.2,0.9 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6l2-3.1c0.2-0.3,0.2-0.6,0.2-0.9 C64.8,63.4,64.6,63.2,64.3,63z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M76.1,44.5c-0.6-0.4-1.3-0.2-1.7,0.4l-2,3.1c-0.4,0.6-0.2,1.3,0.4,1.7c0.2,0.1,0.4,0.2,0.6,0.2 c0.4,0,0.8-0.2,1-0.6l2-3.1C76.9,45.6,76.7,44.8,76.1,44.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M83.1,33.6L83.1,33.6c-0.6-0.4-1.3-0.2-1.7,0.4l-1,1.6c-0.2,0.3-0.2,0.6-0.2,0.9 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.8-0.2,1-0.6l1-1.6c0.2-0.3,0.2-0.6,0.2-0.9 C83.5,34,83.4,33.8,83.1,33.6z"
		})
	] }) })
});
export default SvgCountersinkingSm;
